// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fill-width[data-v-1297b040]{width:100%;height:auto}.media-div__inner[data-v-1297b040]{display:block;background-size:cover;background-repeat:no-repeat;background-position:50%;padding-top:100%}img[data-v-1297b040]{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
